import { library } from '@fortawesome/fontawesome-svg-core';
import {} from '@fortawesome/free-brands-svg-icons';
import {
  faArrowAltCircleLeft,
  faSmile,
  faCheckCircle,
  faEnvelope,
  faEye,
  faSearch,
  faCheck,
  faTimes,
} from '@fortawesome/pro-light-svg-icons';
import {
  faChevronRight,
  faHistory,
  faLongArrowLeft, faLongArrowRight,
  faEdit as farEdit,
  faCamera,
  faCheckSquare as farCheckSquare,
  faSquare as farSquare, faKey, faSignIn,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faMapMarkedAlt,
  faBan,
  faFileExcel,
  faFileDownload,
  faChevronCircleDown,
  faCheck as fasChack,
  faCheckCircle as fasCheckCircle,
  faTimes as fasTimes,
  faQuestionCircle,
  faUserLock,
  faDollyFlatbedEmpty,
  faTimesCircle,
  faCaretDown,
  faCaretUp,
  faBriefcase,
  faArrowsAltH,
  faUser,
  faExclamation,
  faExclamationCircle,
  faClock,
  faQrcode,
  faDollarSign,
  faDownload,
  faFileUpload,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChartPie,
  faCaretRight,
  faProjectDiagram,
  faRandom,
  faVial,
  faTruck,
  faPlay,
  faIdCard,
  faPlane,
  faMapMarkerAlt,
  faMapMarker,
  faHandshake,
  faUsers,
  faChevronDown,
  faClone,
  faEdit,
  faTrash,
  faTrashAlt,
  faPlus,
  faSortAmountDownAlt,
  faSort,
  faSortUp,
  faSortDown,
  faArrowDown,
  faTemperatureLow,
  faBoxCheck,
  faDollyFlatbedAlt,
  faAngleRight,
  faAngleLeft,
  faTrashRestoreAlt,
  faStar,
  faRepeatAlt,
  faUpload,
  faFileCheck,
  faTachometerAlt,
  faCheckSquare,
  faSquare,
  faAngleDown,
  faExclamationTriangle,
  faCalendarCheck,
  faTasks,
  faUsersClass,
  faChevronRight as fasChevronRight,
} from '@fortawesome/pro-solid-svg-icons';

export const FontAwesome = () => {
  // regular
  library.add({
    faSignIn,
    faKey,
    faChevronRight,
    faHistory,
    faLongArrowLeft,
    faLongArrowRight,
    farEdit,
    faCamera,
    farCheckSquare,
    farSquare,
  });

  // brands
  library.add({ });

  // solid
  library.add({
    faMapMarkedAlt,
    faBan,
    faFileExcel,
    faFileDownload,
    fasChevronRight,
    faCalendarCheck,
    faTasks,
    faUsersClass,
    faExclamationTriangle,
    faAngleDown,
    faSquare,
    faCheckSquare,
    faUpload,
    faSortUp,
    faSortDown,
    faDollyFlatbedAlt,
    faBoxCheck,
    faTemperatureLow,
    fasCheckCircle,
    faClock,
    faQrcode,
    faDollarSign,
    faDownload,
    faFileUpload,
    faChevronCircleDown,
    faArrowAltCircleLeft,
    fasChack,
    fasTimes,
    faQuestionCircle,
    faUserLock,
    faDollyFlatbedEmpty,
    faTimesCircle,
    faExclamation,
    faCaretDown,
    faCaretUp,
    faBriefcase,
    faArrowsAltH,
    faUser,
    faCaretRight,
    faExclamationCircle,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faChartPie,
    faProjectDiagram,
    faRandom,
    faVial,
    faTruck,
    faPlay,
    faIdCard,
    faPlane,
    faMapMarkerAlt,
    faMapMarker,
    faHandshake,
    faUsers,
    faChevronDown,
    faClone,
    faEdit,
    faTrash,
    faTrashAlt,
    faPlus,
    faSortAmountDownAlt,
    faSort,
    faArrowDown,
    faAngleRight,
    faAngleLeft,
    faTrashRestoreAlt,
    faStar,
    faRepeatAlt,
    faFileCheck,
    faTachometerAlt,
  });

  // light
  library.add({
    faSmile, faCheckCircle, faEnvelope, faEye, faSearch, faCheck, faTimes,
  });
};
